var API = {
    //urlAPI: "http://200.45.208.65:3001/api/"
    //urlAPI: "http://localhost:3001/api/"
    urlAPI: "https://vdpelectro.com.ar/api/api/"
}

export default API